<template lang="pug">
.face
  template(v-for="(row, rix) in rows")
    .cell(
      v-for="(color, cix) in row",
      :style="{ backgroundColor: color }",
      :class="{ 'is-active-selection': isSelected(f, rix, cix) }",
      @click="selectColor(f, rix, cix, $event)"
    )
</template>

<script>
export default {
  props: ["f", "s", "cc", "selected"],
  data() {
    return {
      // Start-Indizes für die 9er Blöcke im Kociemba-String
      offsets: {
        u: 0, // Up
        r: 9, // Right
        f: 18, // Front
        d: 27, // Down
        l: 36, // Left
        b: 45, // Back
      },
    };
  },
  computed: {
    rows() {
      const faceletString =
        this.s || "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
      const start = this.offsets[this.f.toLowerCase()];

      // Die 9 Zeichen für diese Seite extrahieren
      let faceColors = faceletString.substring(start, start + 9).split("");
      // NEU: Wenn es die Back-Seite ist, den String für die Anzeige umdrehen
      if (this.f.toLowerCase() === "b") {
        faceColors = faceColors.reverse();
      }
      const grid = [];
      for (let i = 0; i < 9; i += 3) {
        // Die Zeichen (U, R, F...) in Hex-Farben umwandeln
        const row = faceColors.slice(i, i + 3).map((char) => {
          return this.cc[char.toUpperCase()]
            ? this.cc[char.toUpperCase()].hex
            : "#666666";
        });
        grid.push(row);
      }

      return grid;
    },
  },
  mounted() {},
  methods: {
    selectColor(f, r, c, event) {
      if (r != 1 || c != 1) {
        let targetRow = r;
        let targetCol = c;

        // Wenn es die Back-Seite ist, müssen wir die Koordinaten für den String spiegeln
        if (f.toLowerCase() === "b") {
          // (0,0) wird zu (2,2), (0,1) zu (2,1), etc.
          targetRow = 2 - r;
          targetCol = 2 - c;
        }
        this.$emit("selectColor", { f, r: targetRow, c: targetCol, event });
      }
    },
    isSelected(f, rix, cix) {
      return (
        this.selected &&
        cix == this.selected.c &&
        rix == this.selected.r &&
        f == this.selected.f
      );
    },
  },
};
</script>

<style lang="less" scoped>
.face {
  display: grid;
  grid-template-columns: 2rem 2rem 2rem;
  gap: 2px;
  margin: 2px;
}

.cell {
  height: 2rem;
  width: 2rem;
  border: 1px solid black;
  border-radius: 0.3rem; // Standard: leicht abgerundet
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  box-sizing: border-box;

  &.is-active-selection {
    border-radius: 50% !important; // Macht die Zelle zum Kreis
    border: 3px solid white; // Weißer Kontrastrahmen
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5), 0 0 0 2px black; // Doppelter Rahmen-Effekt
    transform: scale(
      0.9
    ); // Optional: leicht einschrumpfen für "Eingedrückt"-Look
  }
}
</style>